export default __webpack_public_path__ + "static/continuous-integration-0-3a8fd9bf54fef01ecdcc6cdda59b6d0a.png";